module.exports = __webpack_public_path__ + "img/1762097100485-6T93II_L.a42c8599.png";